export default "__VITE_ASSET__CYwwwZZu__"